import React from 'react';
import { useRouteMatch, Route, Switch } from 'react-router-dom';
import LawyerLanding from './LawyerLanding';
import Lawyer from './Lawyer';
import LawyerWithSlug from './LawyerWithSlug';

export default function LawyerPage() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={path} exact>
        <LawyerLanding />
      </Route>
      <Route path={`${path}/profile/:slug`} exact>
        <LawyerWithSlug />
      </Route>
      <Route path={`${path}/:lawyerId`} exact>
        <Lawyer />
      </Route>
    </Switch>
  );
}
